import React from 'react';
import Container from '@/components/ui/Container';
import SectionHeader from '@/components/ui/SectionHeader';
import { IHireBenefits } from '@/components/type/hireUs/hireAiType';

type Props = {
  data: IHireBenefits;
};

const HireBenefits = ({ data }: Props) => {
  return (
    <section className="bg-black py-12 md:py-20 lg:py-[120px]">
      <Container className="flex flex-col gap-10">
        <SectionHeader
          headingText={data.headingText}
          descriptionText={data.descriptionText}
          isSectionDark={true}
          className="mx-auto max-w-[927px] items-center"
        />
        <div className="flex flex-wrap gap-4 md:gap-5">
          {data.items.map((item) => (
            <div
              key={item.title}
              className="grow basis-full rounded-lg border border-white/15 bg-[#161616] p-4 md:basis-[calc(50%-10px)] lg:basis-[calc(33.333%-14px)]"
            >
              <h3 className="text-base font-semibold leading-6 text-white sm:text-lg">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-5 text-white/70 sm:text-base">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default HireBenefits;
